import { apiRequest } from '@/api/client';
import type { AuditEvent } from '@/types';

export async function fetchMyAuditEvents(
  accessToken: string,
  limit = 20,
  sessionId?: string | null,
): Promise<AuditEvent[]> {
  const data = await apiRequest<{ events?: AuditEvent[]; items?: AuditEvent[] }>(
    `/audit/events/me?limit=${limit}`,
    { accessToken, sessionId },
  );
  return data.events ?? data.items ?? (Array.isArray(data) ? data : []);
}
